module.exports = __webpack_public_path__ + "img/image-desk-connect.d0ea7914.svg";